import misRutas from 'vue-routes-generator'
import SubirCunasComponent from './App'

export default {
	install: Vue => {
		misRutas.route('/main').child('subir-cunas', {
			name: 'Subir Cuñas',
			component: SubirCunasComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/subir-cunas/vue/index.js